import {
  Box,
  Divider,
  Stack,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import React, { Fragment } from 'react';
import ScreeningMethodBox from './ScreeningMethodBox';
import type { Props } from './types';

function ProviderScreening({
  intl,
  screeningMethods,
  screeningStatus,
  hasPendingScreeningMethods,
  highlighted,
  children,
}: Props) {
  return (
    <Box
      sx={{
        flex: screeningMethods.length,
        borderRadius: '4px',
        border: '1px solid',
        borderColor: highlighted ? 'primary.main' : 'divider',
        backgroundColor: highlighted ? 'primary.lighter' : undefined,
        padding: 3,
      }}
    >
      <Stack direction="row" gap={2} alignItems="center">
        {screeningMethods.map((method, index) => (
          <Fragment key={method.name}>
            {index !== 0 && (
              <Divider orientation="vertical" variant="middle" flexItem />
            )}
            <ScreeningMethodBox
              intl={intl}
              method={method}
              screeningStatus={screeningStatus}
              hasPendingScreeningMethods={hasPendingScreeningMethods}
            />
          </Fragment>
        ))}
      </Stack>
      {children ? <Box sx={{ marginTop: 2 }}>{children}</Box> : null}
    </Box>
  );
}

export default ProviderScreening;
